import { ShipmentLeadTimeArray } from 'app/modules/settings/domain/entity/ShipmentLeadTimeArray';
import { ShipmentLeadTimeResponse } from 'app/modules/settings/infrastructure/dto/response/ShipmentLeadTimeResponse';
import { ShipmentLeadTimeMapper } from './ShipmentLeadTimeMapper';

export class ShipmentLeadTimeArrayMapper {

    static toDomain(dtos: ShipmentLeadTimeResponse[]): ShipmentLeadTimeArray {
        const items = dtos.map((dto) => ShipmentLeadTimeMapper.toDomain(dto));
        return new ShipmentLeadTimeArray(items);
    }

}
